import { SxProps, Theme } from '@mui/material/styles';
import { CSSProperties } from 'react';

export const addServiceRecordStyles = {
    root: {
        maxWidth: 600,
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    paper: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 3,
    } satisfies SxProps<Theme>,
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    mileageRow: {
        display: 'flex',
        gap: 2,
    } satisfies SxProps<Theme>,
    uploadArea: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px dashed',
        borderColor: 'divider',
        borderRadius: 2,
        py: 4,
        cursor: 'pointer',
        '&:hover': {
            borderColor: 'primary.main',
            bgcolor: 'primary.50',
        },
    } satisfies SxProps<Theme>,
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 2,
    } satisfies SxProps<Theme>,
};

export const uploadIconStyles: CSSProperties = {
    marginBottom: 8,
};

export const hiddenInputStyles: CSSProperties = {
    display: 'none',
};
